module.exports = __webpack_public_path__ + "img/234.a15a75c2.png";